import { useStore } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { createStore } from 'zustand/vanilla'

interface RoomSelectionServiceState {
  isRoomBeingSelected: boolean
}

interface RoomSelectionServiceStoreActions {
  startSelectingRoomService: () => void
  endSelectingRoomService: () => void
}

type RoomSelectionServiceStore = RoomSelectionServiceState & RoomSelectionServiceStoreActions

export function createRoomSelectionServiceStore(initState: RoomSelectionServiceState) {
  return createStore<RoomSelectionServiceStore>()(
    immer(set => ({
      ...initState,
      startSelectingRoomService() {
        set((state) => {
          state.isRoomBeingSelected = true
        })
      },
      endSelectingRoomService() {
        set((state) => {
          state.isRoomBeingSelected = false
        })
      },
    })),
  )
}

export function roomSelectionServiceIsBeingSelected() {
  return ({ isRoomBeingSelected }: RoomSelectionServiceState) => {
    return isRoomBeingSelected || false
  }
}

export const roomSelectionServiceStore = createRoomSelectionServiceStore({
  isRoomBeingSelected: false,
})

type StoreSelector<T, S> = (state: S) => T
interface UseBoundStore<S> {
  (): S
  <T>(selector: StoreSelector<T, S>): T
}

export const useRoomSelectionServiceStore: UseBoundStore<RoomSelectionServiceStore> = <T>(selector?: StoreSelector<T, RoomSelectionServiceStore>) => {
  const store = useStore(roomSelectionServiceStore)

  if (!selector) {
    return store
  }

  return selector(store)
}
